import { NavDropdown } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import ChildMenuItemList from "./ChildMenuItemList";
import classes from "./ParentNavMenu.module.css";

const ParentNavMenu = ({
  item,
  index,
  showModalsHandler,
  closeModalsHandler,
  childDrop1IsOpen,
  childDrop2IsOpen,
  modalHrefHandler,
  modalTitle,
  showChildMenuHandler,
  closeChildMenuHandler,
  modalContents,
  ModalContentList,
}) => {
  return (
    <div className={classes["parent-nav-menu"]}>
      <NavDropdown
        title={<FormattedMessage id={formatText(item.title)} />}
        id={index}
        onMouseEnter={() => showChildMenuHandler(item.ID)}
        onMouseLeave={() => closeChildMenuHandler()}
        show={item.isOpen}
      >
        <ChildMenuItemList
          item={item}
          closeModalsHandler={closeModalsHandler}
          showModalsHandler={showModalsHandler}
          childDrop1IsOpen={childDrop1IsOpen}
          childDrop2IsOpen={childDrop2IsOpen}
          modalHrefHandler={modalHrefHandler}
          modalTitle={modalTitle}
          closeChildMenuHandler={closeChildMenuHandler}
          modalContents={modalContents}
          ModalContentList={ModalContentList}
        />
      </NavDropdown>
    </div>
  );
};

export default ParentNavMenu;
